// export const bucketName='https://pro-spaces-profile.s3.ap-south-1.amazonaws.com/profile'
export const bucketName =
  "https://s3.ap-south-1.amazonaws.com/prochure.in.profile/profile";
